import React from 'react'

import Headline from './Headline'
import Episode from './Episode'
import Section from './Section'

const EpisodeSummary = ({ ep, expanded = false, readMore = false, children }) => (
  <Section key={ep.number}>
    <Headline above={`Episode ${ep.number}`} prerelease={ep.unreleased}>
      { ep.title }
    </Headline>
    <Episode {...{ep, expanded, readMore}}/>
    { children }
  </Section>
)

export default EpisodeSummary



/** WEBPACK FOOTER **
 ** ./src/components/EpisodeSummary.js
 **/